'use strict';

function EmailToObjectService(config, $resource) {
  return $resource(config.apiBase + '/companies/:companyId/emails/:emailId', {}, {
    "update": {
      url: config.apiBase + '/companies/:companyId/emails/:emailId',
      method: 'PUT'
    }
  });
}

angular.module('dokiv')
  .factory('EmailToObjectService', ['config', '$resource', EmailToObjectService]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/email-to-object/EmailToObjectService.js
// module id = 345
// module chunks = 0